module.exports = __webpack_public_path__ + "img/6.df7de1c1.png";